<template>
  <img :src="image_url" alt="{{image_alt}}" class="card-img">
  <a :href="permalink" class="card-link">
    <p class="h2">{{ title }}</p>
  </a>
</template>

<script>
export default {
  props: ["title", "permalink", "image"],
  setup(props) {
    const title = props.title;
    const permalink = props.permalink;
    const image_alt = props.image.alt;
    const image_url = props.image.url;

    return { title, permalink, image_alt, image_url };
  },
};
</script>
